<template lang="pug">
  .header__menu
    .header__menu-left
      RouterLink.header__menu-item(
        @click="_txq.push(['track', 'navigation'])"
        v-for="item in left"
        :key="item.title"
        :to="{query: $route.query, ...item.to }"
      ) {{ item.title }}
    RouterLink.header__menu-logo(:to="{query: $route.query, name: 'home'}")
    .header__menu-right
      RouterLink.header__menu-item(
        @click="_txq.push(['track', 'navigation'])"
        v-for="item in right"
        :key="item.title"
        :to="{query: $route.query, ...item.to }"
      ) {{ item.title }}
      .header__menu-item.header__menu-item_feedback(v-tap="showModal")
        | {{ $t('header.feedback') }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderTopMenu',
  computed: {
    ...mapGetters('main', ['menu']),
    left: vm => vm.menu.slice(0, 3),
    right: vm => vm.menu.slice(3)
  },
  methods: {
    showModal () {
      this.$modal.show('ModalFeedback')
    }
  }
}
</script>
